import { useState, useEffect } from 'react'
import propTypes from 'prop-types'
import { gsap } from 'gsap'
import { useGSAP } from '@gsap/react'

import v from '../../../styles/modules/_variables.scss'

const { timing } = v
const timingNumber = Number(timing.slice(0, -1))

const DelayRender = ({
  children,
  duration = timingNumber,
  showCondition,
  selector,
  hiddenStyles,
}) => {
  const [show, setShow] = useState(false)
  const durationMs = duration * 1000

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(showCondition)
    }, durationMs)

    return () => {
      clearTimeout(timer)
    }
  }, [durationMs, showCondition])

  useGSAP(
    () => {
      if (show) {
        gsap.from(selector, {
          duration: duration,
          ease: 'ease-out',
          ...hiddenStyles,
        })
      }
    },
    { dependencies: [show] }
  )

  useGSAP(
    () => {
      if (show) {
        gsap.to(selector, {
          duration: duration,
          ease: 'ease-in',
          ...hiddenStyles,
        })
      }
    },
    { dependencies: [showCondition] }
  )

  return show && children
}

DelayRender.propTypes = {
  children: propTypes.oneOfType([
    propTypes.array,
    propTypes.shape(),
    propTypes.string,
  ]),
  showCondition: propTypes.bool,
  selector: propTypes.string,
  hiddenStyles: propTypes.shape(),
}

export default DelayRender
